import ClientSettingJSON from 'app/assets/jsons/ClientSetting.json';

export function GetClientSettings() {
  const data = ClientSettingJSON.clientSettings;
  return data;
}
